import { Link } from 'gatsby';
import React from 'react';

import { ReactComponent as Separator } from '../../assets/breadcrumb-separator.svg';
import {
	breadcrumb as breadcrumbStyle,
	category as categoryStyle,
	container as containerStyle,
	separator as separatorStyle,
	title as titleStyle,
} from './style.module.css';

export interface BreadcrumbProps {
	category?: string | null;
	title?: string | null;
	slug?: string | null;
}

export const Breadcrumb = ({ category, title, slug }: BreadcrumbProps) => {
	return !category ? (
		<></>
	) : (
		<div className={containerStyle}>
			<div className={breadcrumbStyle}>
				<Link to={`/${slug}`} className={categoryStyle}>
					{category}
				</Link>
				<div className={separatorStyle}>
					<Separator />
				</div>
				<div className={titleStyle}>{title}</div>
			</div>
		</div>
	);
};
